import { ROLES_LIST } from '@/js/constants';
export default [{
  icon: 'icon-summary',
  name: 'overview',
  key: 'menu.attrs.overview',
  link: '/attributes/overview',
  href: {
    name: 'overview'
  },
  roles: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
}, {
  icon: 'icon-groups',
  name: 'Mis grupos',
  key: 'menu.attrs.my_groups',
  link: '/attributes/groups',
  href: {
    name: 'groups'
  },
  roles: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
}, {
  icon: 'icon-monitoring',
  name: 'Calidad Atributos',
  key: 'menu.attrs.reports',
  link: '/attributes',
  href: {
    name: null
  },
  roles: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ATTRIBUTE_SUPERVISOR, ROLES_LIST.ORG_DATA_STEWARD],
  subItems: [{
    name: 'Calidad Atributos',
    key: 'menu.attrs.attribute_quality',
    link: '/attributes/quality-report',
    href: {
      name: 'attribute_quality'
    },
    exact: true,
    roles: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ATTRIBUTE_SUPERVISOR, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Calidad Atributos Compartidos',
    key: 'menu.attrs.attribute_quality_shared',
    link: '/attributes/quality-report/shared',
    href: {
      name: 'quality_report_shared'
    },
    exact: true,
    roles: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ATTRIBUTE_SUPERVISOR, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Calidad Atributos - Consistencia',
    key: 'menu.attrs.attribute_quality_consistency',
    link: '/attributes/quality-report/consistency',
    href: {
      name: 'quality_report_consistency'
    },
    exact: true,
    roles: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ATTRIBUTE_SUPERVISOR, ROLES_LIST.ORG_DATA_STEWARD]
  }]
}, {
  icon: 'icon-case_use',
  name: 'Use Cases',
  key: 'menu.attrs.use_cases',
  link: '/attributes/use_cases',
  roles: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_SUPERVISOR, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD],
  subItems: [{
    name: 'Attribute Search',
    key: 'menu.attrs.search_attributes',
    link: '/attributes/search',
    href: {
      name: 'attributes_search'
    },
    roles: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Create Sandbox',
    key: 'menu.attrs.create_sandbox',
    link: '/attributes/selected',
    href: {
      name: 'attributes_selected'
    },
    roles: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'My Sandboxes',
    key: 'menu.attrs.my_sandboxes',
    link: '/attributes/use_cases/history',
    href: {
      name: 'ownership_history'
    },
    roles: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_SUPERVISOR, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  },
  // {
  //   name: 'Upload My Data',
  //   key: 'menu.attrs.upload_my_data',
  //   link: '',
  //   href: {},
  //   roles: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN]
  // },
  {
    name: 'Productize Model',
    key: 'menu.attrs.productize_model',
    link: '/attributes/use_cases/productize_model',
    roles: [ROLES_LIST.ATTRIBUTE_USER, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD],
    href: {}
  }, {
    name: 'Create Attribute',
    key: 'menu.attrs.create_attribute',
    link: '/attributes/use_cases/create_attribute',
    href: {
      name: 'create_attribute'
    },
    roles: [ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ATTRIBUTE_USER],
    intercorpAdminOnly: false
  }]
}, {
  icon: 'icon-config',
  name: 'Marketplace Setup',
  key: 'menu.attrs.marketplace_setup',
  link: '/attributes/setup',
  roles: [ROLES_LIST.ATTRIBUTE_ADMIN],
  subItems: [{
    name: 'Requests',
    key: 'menu.attrs.manage_requests',
    link: '/attributes/use_cases/requests',
    href: {
      name: 'requests'
    },
    roles: [ROLES_LIST.ATTRIBUTE_ADMIN]
  }, {
    name: 'ManageProductionDeployments',
    key: 'menu.attrs.manage_production',
    link: '/attributes/use_cases/manage_production',
    href: {
      name: 'manage_production'
    },
    roles: [ROLES_LIST.ATTRIBUTE_ADMIN]
  }, {
    name: 'Sandboxes',
    key: 'menu.attrs.sandboxes',
    link: '/attributes/use_cases/sandboxes',
    href: {
      name: 'sandboxes'
    },
    roles: [ROLES_LIST.ATTRIBUTE_ADMIN]
  },
  // {
  //   name: 'Production Approvals',
  //   key: 'menu.attrs.production_approvals',
  //   link: '/attributes/setup/sandbox_request',
  //   href: {}
  // },
  // {
  //   name: 'User Tables Overview',
  //   key: 'menu.attrs.user_tables_overview',
  //   link: '/attributes/setup/attributes_metadata',
  //   href: {}
  // },
  // {
  //   name: 'Business Case Indicators',
  //   key: 'menu.attrs.business_case_indicators',
  //   link: '/attributes/setup/attributes_metadata',
  //   href: {}
  // },
  {
    name: 'Attribute Master',
    key: 'menu.attrs.attribute_master',
    link: '/attributes/managment/attribute_master',
    href: {}
  }, {
    name: 'Metrics',
    key: 'menu.attrs.metrics',
    link: '/attributes/managment/metrics',
    href: {
      name: 'metrics'
    },
    roles: [ROLES_LIST.ATTRIBUTE_ADMIN]
  }, {
    name: 'Manage Metrics Report',
    key: 'menu.attrs.manage_metrics',
    link: '/attributes/managment/manage_metrics',
    href: {
      name: 'manage_metrics'
    },
    roles: [ROLES_LIST.ATTRIBUTE_ADMIN]
  }, {
    icon: 'icon-monitoring',
    name: 'Calidad Atributos',
    key: 'menu.attrs.manage_quality_report',
    link: '/attributes/managment/quality-report',
    href: {
      name: 'manage_quality_report'
    },
    roles: [ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ORG_DATA_STEWARD]
  }]
}];